import { RegistrationFacade } from './../../store/registration/facade/registration.facade';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { filter, take, switchMap, catchError } from 'rxjs/operators';

@Injectable()
export class RegistrationGuard  {

    constructor(private facade: RegistrationFacade) { }

    getRegistrationSteps(): Observable<any> {
        return this.facade.loadRegistrationSteps().pipe(
            filter((result) => result.investor.details !== undefined),
            take(1)
        );
    }

    // Ensure that registration steps data has been loaded prior
    // to activating the route.
    canActivate(): Observable<boolean> {
        return this.getRegistrationSteps().pipe(
            switchMap(() => of(true)),
            catchError(() => of(false))
        );
    }
}
